import { useFormContext, useWatch } from 'react-hook-form';
import { HotelFormDataWithTranslations } from '@/i18n/translation-type-utils';

/** Whether the hotel form is in Expert mode (tariffs pasted from Excel). */
export const useExpertMode = () => {
  const { control } = useFormContext<HotelFormDataWithTranslations>();
  return useWatch({ control, name: 'expertMode' }) === 'true';
};
